import React, { useEffect, useState } from "react";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import {
  fetchTagsCountryData,
  fetchTagsTypologyData,
} from "../../../service/DashboardService";
import loader from "../../../assets/images/loader.gif";

const AllTags = () => {
  const [selectedRadio, setSelectedRadio] = useState("typology");
  const [countryData, setCountryData] = useState([]);
  const [typologyData, setTypologyData] = useState([]);
  const [totalProjects, setTotalProjects] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (selectedRadio === "country") {
          const data = await fetchTagsCountryData();
          setCountryData(data);
          setTotalProjects(data[0]?.totalProjects || 0);
        } else if (selectedRadio === "typology") {
          const data = await fetchTagsTypologyData();
          setTypologyData(data);
          setTotalProjects(
            data.reduce(
              (acc, typology) =>
                acc +
                typology.SubCategories.reduce(
                  (subAcc, sub) => subAcc + sub.SubTypologyCount,
                  0
                ),
              0
            )
          );
        }
      } catch (error) {
        console.error("Error fetching tags data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedRadio]);

  const handleRadioChange = (event) => {
    setSelectedRadio(event.target.value);
  };

  return (
    <>
      <TopHeader />
      {/* <SearchBar /> */}

      {loading ? (
        <div className="flex justify-center ">
          <img src={loader} alt="Loading" />
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center">
          <h1 className="font-semibold">Total Projects: {totalProjects}</h1>

          <div className="flex items-center gap-4">
            <div className="flex items-center ps-4 border border-gray-200 rounded dark:border-gray-700">
              <input
                id="bordered-radio-1"
                type="radio"
                value="typology"
                name="bordered-radio"
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                checked={selectedRadio === "typology"}
                onChange={handleRadioChange}
              />
              <label
                htmlFor="bordered-radio-1"
                className="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                By Typology
              </label>
            </div>
            <div className="flex items-center ps-4 border border-gray-200 rounded dark:border-gray-700">
              <input
                id="bordered-radio-2"
                type="radio"
                value="country"
                name="bordered-radio"
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                checked={selectedRadio === "country"}
                onChange={handleRadioChange}
              />
              <label
                htmlFor="bordered-radio-2"
                className="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                By Country
              </label>
            </div>
          </div>
        </div>
      )}

      {typologyData.length === 0 && countryData.length === 0 ? (
        <div className="flex justify-center items-center mt-10">
          <p>No records found</p>
        </div>
      ) : (
        <>
          {selectedRadio === "typology" && (
            <div className="max-w-screen-md mx-auto px-5 bg-white ">
              <div className="grid divide-y divide-neutral-200 max-w-xl mx-auto mt-8">
                {typologyData.map((typology, index) => (
                  <div className="py-5" key={index}>
                    <details className="group">
                      <summary className="flex justify-between items-center font-medium cursor-pointer list-none">
                        <p className="flex items-center gap-4">
                          <span>{typology.TypologyCategory}</span>
                          <span>{typology.TypologyCount}</span>
                        </p>

                        <span className="transition group-open:rotate-180">
                          <svg
                            fill="none"
                            height="24"
                            shape-rendering="geometricPrecision"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.5"
                            viewBox="0 0 24 24"
                            width="24"
                          >
                            <path d="M6 9l6 6 6-6"></path>
                          </svg>
                        </span>
                      </summary>
                      {typology.SubCategories.map((sub, i) => (
                        <p
                          className="text-neutral-600 mt-3 group-open:animate-fadeIn flex items-center justify-between"
                          key={i}
                        >
                          <span>{sub.TypologySubCategory}</span>
                          <span>{sub.SubTypologyCount}</span>
                        </p>
                      ))}
                    </details>
                  </div>
                ))}
              </div>
            </div>
          )}

          {selectedRadio === "country" && (
            <div className="max-w-screen-md mx-auto px-5 bg-white ">
              <div className="grid divide-y divide-neutral-200 max-w-xl mx-auto mt-8">
                {countryData.map((country, index) => (
                  <div className="py-5" key={index}>
                    <details className="group">
                      <summary className="flex justify-between items-center font-medium cursor-pointer list-none">
                        <span>{country.countryName}</span>
                        <span>{country.count}</span>
                      </summary>
                    </details>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default AllTags;
